export const options = [
  { label: 'All notifications, except the ones you unsubscribe from in emails.', value: 1 },
  { label: 'Only notifications related to my membership (~5 emails a season).', value: 2 },
  { label: 'Only notifications related to my account (no promotional emails).', value: 3 },
];
